import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { removeNonTranslationalTransform } from '../dom/utils/unit-conversion.mjs';
import { frame } from '../../frameloop/frame.mjs';
var toResolve = new Set();
var isScheduled = false;
var anyNeedsMeasurement = false;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    var resolversToMeasure = Array.from(toResolve).filter(function (resolver) {
      return resolver.needsMeasurement;
    });
    var elementsToMeasure = new Set(resolversToMeasure.map(function (resolver) {
      return resolver.element;
    }));
    var transformsToRestore = new Map();
    /**
     * Write pass
     * If we're measuring elements we want to remove bounding box-changing transforms.
     */
    elementsToMeasure.forEach(function (element) {
      var removedTransforms = removeNonTranslationalTransform(element);
      if (!removedTransforms.length) return;
      transformsToRestore.set(element, removedTransforms);
      element.render();
    });
    // Read
    resolversToMeasure.forEach(function (resolver) {
      return resolver.measureInitialState();
    });
    // Write
    elementsToMeasure.forEach(function (element) {
      element.render();
      var restore = transformsToRestore.get(element);
      if (restore) {
        restore.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          var _a;
          (_a = element.getValue(key)) === null || _a === void 0 ? void 0 : _a.set(value);
        });
      }
    });
    // Read
    resolversToMeasure.forEach(function (resolver) {
      return resolver.measureEndState();
    });
    // Write
    resolversToMeasure.forEach(function (resolver) {
      if (resolver.suspendedScrollY !== undefined) {
        window.scrollTo(0, resolver.suspendedScrollY);
      }
    });
  }
  anyNeedsMeasurement = false;
  isScheduled = false;
  toResolve.forEach(function (resolver) {
    return resolver.complete();
  });
  toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach(function (resolver) {
    resolver.readKeyframes();
    if (resolver.needsMeasurement) {
      anyNeedsMeasurement = true;
    }
  });
}
function flushKeyframeResolvers() {
  readAllKeyframes();
  measureAllKeyframes();
}
var KeyframeResolver = /*#__PURE__*/function () {
  function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
    var isAsync = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    _classCallCheck(this, KeyframeResolver);
    /**
     * Track whether this resolver has completed. Once complete, it never
     * needs to attempt keyframe resolution again.
     */
    this.isComplete = false;
    /**
     * Track whether this resolver is async. If it is, it'll be added to the
     * resolver queue and flushed in the next frame. Resolvers that aren't going
     * to trigger read/write thrashing don't need to be async.
     */
    this.isAsync = false;
    /**
     * Track whether this resolver needs to perform a measurement
     * to resolve its keyframes.
     */
    this.needsMeasurement = false;
    /**
     * Track whether this resolver is currently scheduled to resolve
     * to allow it to be cancelled and resumed externally.
     */
    this.isScheduled = false;
    this.unresolvedKeyframes = _toConsumableArray(unresolvedKeyframes);
    this.onComplete = onComplete;
    this.name = name;
    this.motionValue = motionValue;
    this.element = element;
    this.isAsync = isAsync;
  }
  return _createClass(KeyframeResolver, [{
    key: "scheduleResolve",
    value: function scheduleResolve() {
      this.isScheduled = true;
      if (this.isAsync) {
        toResolve.add(this);
        if (!isScheduled) {
          isScheduled = true;
          frame.read(readAllKeyframes);
          frame.resolveKeyframes(measureAllKeyframes);
        }
      } else {
        this.readKeyframes();
        this.complete();
      }
    }
  }, {
    key: "readKeyframes",
    value: function readKeyframes() {
      var unresolvedKeyframes = this.unresolvedKeyframes,
        name = this.name,
        element = this.element,
        motionValue = this.motionValue;
      /**
       * If a keyframe is null, we hydrate it either by reading it from
       * the instance, or propagating from previous keyframes.
       */
      for (var i = 0; i < unresolvedKeyframes.length; i++) {
        if (unresolvedKeyframes[i] === null) {
          /**
           * If the first keyframe is null, we need to find its value by sampling the element
           */
          if (i === 0) {
            var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
            var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) {
              unresolvedKeyframes[0] = currentValue;
            } else if (element && name) {
              var valueAsRead = element.readValue(name, finalKeyframe);
              if (valueAsRead !== undefined && valueAsRead !== null) {
                unresolvedKeyframes[0] = valueAsRead;
              }
            }
            if (unresolvedKeyframes[0] === undefined) {
              unresolvedKeyframes[0] = finalKeyframe;
            }
            if (motionValue && currentValue === undefined) {
              motionValue.set(unresolvedKeyframes[0]);
            }
          } else {
            unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
          }
        }
      }
    }
  }, {
    key: "setFinalKeyframe",
    value: function setFinalKeyframe() {}
  }, {
    key: "measureInitialState",
    value: function measureInitialState() {}
  }, {
    key: "renderEndStyles",
    value: function renderEndStyles() {}
  }, {
    key: "measureEndState",
    value: function measureEndState() {}
  }, {
    key: "complete",
    value: function complete() {
      this.isComplete = true;
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
      toResolve.delete(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (!this.isComplete) {
        this.isScheduled = false;
        toResolve.delete(this);
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (!this.isComplete) this.scheduleResolve();
    }
  }]);
}();
export { KeyframeResolver, flushKeyframeResolvers };